var $body = $('body');
var $mobileNavMenu = $('.js-mobile-navigation');
var $dropdown = $('nav .dropdown');
var $dropdownSubmenu = $('.dropdown-submenu');
var $flyout = $('[data-flyout="left-flyout"]');
var $mobileVehicleLinks = $('.js-mobile-vehicle-link');


$(function () {
    getScrollbarWidth();
    
    var $mainOverlay = $('.js-overlay');
    $('[data-toggle="popover"]').popover();

    // When a dropdown menu is clicked on
    $(document).on('click', '.dropdown-menu', function (e) {
        e.stopPropagation();

        var $dropdownMenu = $(this);
        // If it wants to stay open when you click on it (like desktop nav)
        if ($dropdownMenu.hasClass('keep-open-on-click')) {
            // Still close child dropdowns and collapsibles though
            $dropdownMenu.find('.dropdown.show.close-on-parent-click').each(function () {
                $(this).dropdown('toggle');
            });
            $dropdownMenu.find('.collapse.show.close-on-parent-click').each(function () {
                $(this).collapse('hide');
            });
        }
    });

    // Nested dropdown functionality
    $dropdownSubmenu.on('click', function (e) {
        var $menu = $('.dropdown-menu', $(this));
        $menu.toggle();

        e.stopPropagation();
        e.preventDefault();
    });

    // When body is clicked, check to see if mobile nav is open.
    $mainOverlay.on('click', function (e) {
        if ($flyout.hasClass('show')) {
            // Fire close event.
            $flyout.filter('.show').collapse('hide');
        }
    });

    // When mobile nav opens/closes, add/remove class to body.
    $flyout.on('click', function(e) {
        // This has to be here for Safari-only for some reason...
        var $currentFlyout = $(e.currentTarget);
        var $element = $(e.target);

        // If closing element, then let's go ahead and actually close it.
        if ($element.data('toggle') == 'collapse') {
            // Check if it's target/href is the same as this flyout
            var $flyoutTarget = $((typeof $element.data('target') === 'undefined' ? $element.attr('href') : $element.data('target')));

            $flyoutTarget.collapse('hide');
        }
    });

    $mobileNavMenu
        .on('show.bs.collapse', function() {
            $mainOverlay.removeClass('hide');
        })
        .on('shown.bs.collapse', function() {
            $body.addClass('mobile-nav-open');
            $mainOverlay.addClass('show');
        })
        .on('hide.bs.collapse', function(e) {
            if (!$(e.target).parents().hasClass('collapse') &&
                !$mobileNavMenu.not(e.target).hasClass('show')) {
                $mainOverlay.removeClass('show');
            }
        })
        .on('hidden.bs.collapse', function(e) {
            if (!$(e.target).parents().hasClass('collapse') &&
                !$mobileNavMenu.not(e.target).hasClass('show')) {
                $body.removeClass('mobile-nav-open');
                $mainOverlay.addClass('hide');
            }
        });

    // Show/hide transparency layer when nav opens/closes.
    $dropdown
        .on('show.bs.dropdown', function () {
            $mainOverlay.addClass('show');
        })
        .on('hide.bs.dropdown', function (e) {
            if (!$(e.target).parents().hasClass('collapse')) {
                $mainOverlay.removeClass('show');
            }
        });

    $mobileVehicleLinks.on('click', function() {
        var vehicleURL = $(this).attr('data-vehicle-url');
        if ( vehicleURL ) {
            window.location.href = vehicleURL;
        }
    });

    /**
     * Email Signup Form
     */

    var $emailModalForm = $('.sign-up-form');
    var $emailSignupForm = $('#emailSignupForm');
    var $emailSignup = $('#footerEmailSignupModal');
    var $emailSignupSuccess = $('#emailSignupSuccess');

    //Footer email sign up submit handler
    $emailModalForm.on('submit', function (e) {
        e.preventDefault();

        var $emailInput = $emailModalForm.find('input[name="email"]');

        if (!$emailInput[0].checkValidity()) {
            return false;
        }

        $emailSignup.find('.js-sign-up').show();

        // Copy over the email to the modal form.
        $emailSignupForm.find('input[name="email"]').val($emailModalForm.find('input[name="email"]').val());

        $emailSignup.modal({focus: true, show: true});

        return false;
    });

    //Footer email sign up submit handler
    $emailModalForm.find('input[name="email"]').on('blur', function (e) {
        e.preventDefault();

        if (e.target.checkValidity()) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
        } else {
            $(this).removeClass('is-valid');
            $(this).addClass('is-invalid');
        }
    });

    //Email sign up input listeners
    $emailSignupForm.find('input').on('blur', function (e) {
        e.preventDefault();
        if (e.target.checkValidity()) {
            $(this).removeClass('is-invalid');
            $(this).addClass('is-valid');
        } else {
            $(this).removeClass('is-valid');
            $(this).addClass('is-invalid');
        }
    });

    //Email sign up form submit binding
    $emailSignupForm.on('submit', function (e) {
        e.preventDefault();

        $(this).find('.vehicleSelectorError').addClass('d-none');

        // Toggle validity classes for each input.
        if (!e.target.checkValidity()) {
            $(this).find('input').each(function (i, item) {
                if (!item.checkValidity()) {
                    $(item).removeClass('is-valid');
                    $(item).addClass('is-invalid');
                }
            });
            return false;
        }

        // if this was triggered automatically for a new user,
        // set the analytics variables to track it
        if ($emailSignupForm.data('autoOpen')) {
            dataLayer.push({
                'event': 'signupFromModal',
                'virtualPageURL': '/signupFromModal/emailSubmit',
                'virtualPageTitle': 'Signup From Modal - Email Submit'
            });
        }

        // If the first vehicle selection is 'n', it has not been initialized.
        // Because of how the js works for fetching the vehicle data, the "finished" global
        // we have can be 'true' here, so we have to look at the first input value.
        if ($(this).find('select[name="vstep_1"]').val() === 'n') {
            $(this).find('.vehicleSelectorError').removeClass('d-none');
            return false;
        }

        // Vehicle selection is in progress, but the "finished" global hasn't been set.
        if (!window.emailVehicleSelectEnd) {
            $(this).find('.vehicleSelectorError').removeClass('d-none');
            return false;
        }

        //Set the hidden email verify input to be the same as the email.
        $(this).find('input[name="email_verify"]').val($(this).find('input[name="email"]').val());

        $emailSignupForm.find('.submitError').addClass('d-none');
        $emailSignupForm.find('.next-step-btn').prop('disabled', true);

        // Fix the signup url for /[a-z]/ site experiments when coming from non home page pages.
        // ER-1323
        var pathSplit = window.location.pathname.split('/');
        var url = '/Signup/';
        if(pathSplit[1] && pathSplit[1].length === 1){
            url = '/'+pathSplit[1]+'/Signup/';
        }

        $.ajax({
            url: url,
            type: 'post',
            data: $(this).serialize(),
            success: function (data, status, xhr) {
                if ( data && data.error ) {
                    $emailSignupForm.find( '.submitError' ).removeClass( 'd-none' );
                    return;
                }
                $emailSignup.modal('hide');
                $emailSignupSuccess.modal('show');
            },
            error: function (error) {
                console.error(error);
                $emailSignupForm.find('.submitError').removeClass('d-none');
            },
            complete: function () {
                $emailSignupForm.find('.next-step-btn').prop('disabled', false);
            }
        });

        return false;
    });

    //Footer tune in modal vehicle selector
    var selectedSteps = [];
    var loadedSteps = [];
    var stepLabels = [ 'Make', null, null ];
    $('.vehicle-select-wrap').find('select').on('change', function (e) {
        var $parent = $(this).parent();
        var vstep = $(this).attr('data-name');
        var val = $(this).val();

        //Remove following form groups from what we just changed.
        var $removeSteps = $parent.nextAll( '.form-group' );
        for( var i = 0; i < $removeSteps.length; i ++ ) stepLabels.pop();
        $removeSteps.remove();

        selectedSteps = [];
        loadedSteps = [];
        // Build a step selection from the existing selects
        $parent.prevAll('.form-group').each(function (i, item) {

            var thisVstep = $(item).find('select').attr('data-name');
            var thisValue = $(item).find('select').val();

            selectedSteps.push({
                'vstep': thisVstep,
                'value': thisValue
            });
            loadedSteps.push(thisVstep);
        });

        // Add the current select to the selected steps
        selectedSteps.push({
            'vstep': vstep,
            'value': val
        });

        // set values for listrak
        if ( window._ltk ) {
            var lastStepLabel = stepLabels[ stepLabels.length - 1 ];
            _ltk.Signup.SetValue( 'Modal', lastStepLabel, val );
        }

        var requestURL = '/includes/vehicleMap.cgi?vehicleSelection=1';
        selectedSteps.forEach(function (item) {
            requestURL += '&' + item.vstep + '=' + encodeURIComponent(item.value);
        });

        window.emailVehicleSelectEnd = false;
        $.ajax({
            'url': requestURL,
            'type': 'GET',
            'dataType': 'text'
        }).done(function (data) {
            var lines = data.split('\n');

            var $tpl = null;
            lines.forEach(function (line) {
                var parsed = parseLine(line);

                if (parsed.vstep === 'END') {
                    $emailSignupForm.find('.vehicleSelectorError').addClass('hidden');
                    window.emailVehicleSelectEnd = true;
                    return;
                }

                // Create a select container if we have a new vstep recorded. Deals with a scenario
                // when the request returns multiple vsteps in one shot.
                if (loadedSteps.indexOf(parsed.vstep) === -1) {
                    $tpl = $('.vehicle-select-wrap').find('.vehicle-select-wrap-tpl').clone(true);
                    $tpl.attr('data-name', parsed.vstep);
                    $tpl.find('select').attr('data-name', parsed.vstep);
                    $tpl.find('select').attr('name', parsed.vstep);
                    $tpl.removeClass('hidden').removeClass('vehicle-select-wrap-tpl').addClass('form-group');

                    // Select with options that need filled
                    if (parsed.value === 'n') {
                        $tpl.find('label').html(parsed.name + ':');
                        stepLabels.push( parsed.name );
                    } else { // Hide the selects that auto fill with a single item
                        $tpl.addClass('hidden');
                    }

                    $('.vehicle-select-wrap').append($tpl);

                    loadedSteps.push(parsed.vstep);
                }

                // Build the option out and append it to the new tpl
                var $option = $('<option value="' + parsed.value + '">' + parsed.name + '</option>');
                $option.appendTo($tpl.find('select'));
            });
        });
    });

    function parseLine(line) {
        //get the array from vstep_x::name::value. we'll turn it into an object
        var data = line.split('::');
        if (data.length === 2) {
            return {
                'vstep': data[0],
                'name': data[1]
            }
        }
        else {
            return {
                'vstep': data[0],
                'name': data[1],
                'value': data[2]
            }
        }
    }

    $emailSignupSuccess.find('.js-add-new-vehicle').click(function (e) {
        $emailSignup.find('.js-sign-up').hide();

        // clear out the vehicle selection
        var steps = $emailSignup.find('.vehicle-select-wrap select');
        $(steps[0]).val('');
        $(steps[1]).val('').trigger('change');

        $emailSignupSuccess.modal('hide');
        $emailSignup.modal('show');
        e.preventDefault();
    });

    // Print the current page
    $('.js-print-link').on('click', function(e) {
        e.preventDefault();
        window.print();
    });

    var vehicleSelector = new VehicleSelectorV2($('.vehicle-selector-stepwise-container-guidednav'));
    var vehicleSelectorMobile = new VehicleSelectorV2($('.vehicle-selector-stepwise-container-mobile-guidednav'));

    var vehicleInited = false;
    var mobileVehicleInited = false;

    vehicleSelector.onHasSelectedVehicle(function() {
        vehicleInited = true;
    });

    vehicleSelector.onHasNoSelectedVehicle(function() {
        $('.guided-navigation-clear-vehicle').addClass('d-none');
    });

    vehicleSelector.onVehicleSelected(function(response) {
        if(!vehicleInited) {
            window.location.href = response.newLocation;
        } else {
            $('.guided-navigation-clear-vehicle').removeClass('d-none');
            vehicleInited = false;
        }
    });

    vehicleSelector.onHasPartialVehicleSelected(function() {
        $('.guided-navigation-clear-vehicle').removeClass('d-none');
        vehicleInited = false;
    });

    vehicleSelectorMobile.onHasSelectedVehicle(function() {
        mobileVehicleInited = true;
    });

    vehicleSelectorMobile.onVehicleSelected(function(response) {
        if(!mobileVehicleInited) {
            window.location.href = response.newLocation;
        } else {
            mobileVehicleInited = false;
        }
    });

    vehicleSelectorMobile.onHasPartialVehicleSelected(function() {
        mobileVehicleInited = false;
    });

    vehicleSelector.init();
    vehicleSelectorMobile.init();
});
